import React, { useState, useEffect } from "react";
import { reduxForm, Field, initialize, FieldArray } from "redux-form";
import { Grid, Header, Button, Table } from "semantic-ui-react";
import { renderTextField, renderOptionField } from "../formcomponents";
import axios from "axios";
import {
  BaseUrl,
  BaseUrlInvoice,
  BaseImgUploadUrl,
  ImageUrl,
} from "../formcomponents/Constants";
import ImageFileUploadFileId from "../formcomponents/ImageFileUploadFileId";
import { useNavigate, useParams } from "react-router-dom";
import Swal from "sweetalert2";
import { userData } from "../store/userData";
import FileUpladArr from "./FileUplaad/FileUpladArr";
const validate = (values) => {
  const errors = {};
  if (!values.purchaseDate) {
    errors.purchaseDate = "Required";
  }
  if (!values.buyerCompany) {
    errors.buyerCompany = "Required";
  }
  if (!values.description) {
    errors.description = "Required";
  }
  if (!values.payCompany) {
    errors.payCompany = "Required";
  }
  if (!values.bankName) {
    errors.bankName = "Required";
  }
  if (!values.chequePaymentDate) {
    errors.chequePaymentDate = "Required";
  }
  if (!values.debitDate) {
    errors.debitDate = "Required";
  }
  if (!values.payment) {
    errors.payment = "Required";
  }
  if (!values.toatl) {
    errors.toatl = "Required";
  }

  return errors;
};
const CreatePurchase = (props) => {
  const { handleSubmit, pristine, reset, submitting } = props;
  const navigate = useNavigate();
  const { id, catid } = useParams();
  const userDectail = userData();
  const [fieldDisable, setfieldDisable] = useState(false);
  const [buttonDisable, setbuttonDisable] = useState(false);
  const [downloadImage, setdownloadImage] = useState();
  const [uploadedImageList, setuploadedImageList] = useState([]);
  useEffect(() => {
    if (id != "null") {
      getVisaDetail();
    }
    if (userDectail.userRole != 1 && id != "null") {
      setfieldDisable(true);
      if (userDectail.userRole != 1) {
        setbuttonDisable(true);
      }
    }
  }, []);

  const getVisaDetail = () => {
    axios
      .post(BaseUrlInvoice + "accounts/listPurchase", {
        userId: userDectail.userId,
        categoryId: catid,
        listAll: 0,
      })
      .then((res) => {
        console.log(res.data);
        console.log(id);
        const tempData = res.data;
        //setrowData(res.data);
        //setDataForExcel(res.data);
        const findData = tempData.find((item) => item.purchaseId == id);
        console.log(JSON.stringify(findData, null, 2));

        if (findData.chequeCopy != "null") {
          setdownloadImage(findData.chequeCopy);
        }
        initializeData(findData);
      })
      .catch((error) => {
        console.log(error);
      });
  };
  const initializeData = (data) => {
    props.initialize({
      purchaseId: id,
      categoryId: catid,
      purchaseDate: data.purchaseDate,
      buyerAccountNumber: data.buyerAccountNumber,
      buyerCompany: data.buyerCompany,
      description: data.description,
      payCompany: data.payCompany,
      bankName: data.bankName,
      chequePaymentDate: data.chequePaymentDate,
      debitDate: data.debitDate,
      payment: data.payment,
      toatl: data.toatl,
      remark: data.remark,
      categoryId: data.categoryId,
      userId: data.userId,
      chequeCopy: data.chequeCopy,
      fileList: [{}],
    });
    setuploadedImageList(data.fileList);
  };

  const statusVal = [
    { text: "DRAFT", value: "DRAFT" },
    { text: "POSTED", value: "POSTED" },
    { text: "TYPED", value: "TYPED" },
    { text: "READY TO PAY", value: "READY TO PAY" },
    { text: "POSTED", value: "POSTED" },
    { text: "APPROVED", value: "APPROVED" },
  ];
  const sumbitForm = (values) => {
    // Ensure both fileList and uploadedImageList are arrays (even if undefined)
    const imageList = [...(values.fileList || []), ...(uploadedImageList || [])]
      // Filter out null or undefined values
      .filter((file) => file !== null && file !== undefined);

    console.log(imageList);

    const postObject = {
      ...values,
      fileList: imageList.length === 0 ? [{}] : imageList, // If imageList is empty, set [{}]
      categoryId: catid,
      userId: userDectail.userId,
    };

    console.log(`Your Values:\n\n${JSON.stringify(postObject, null, 2)}`);

    axios
      .post(BaseUrlInvoice + "accounts/createPurchase", postObject)
      .then((res) => {
        console.log(res.data);
        Swal.fire("Success", "Data Added", "success");
        navigate(`/purchase-list/${res.data.categoryId}`);
      })
      .catch((error) => {
        console.log(error);
        Swal.fire("error", "Something Went Wrong", "error");
      });

    console.log(values);
  };

  const handleClick = (event, url) => {
    // 👇️ refers to the image element
    window.open(url, "_blank", "noopener,noreferrer");
  };
  return (
    <div>
      <Grid.Row>
        <Header dividing size="huge" as="h1">
          Purchase Creation
        </Header>
      </Grid.Row>
      <br />
      <Grid.Row>
        <Grid columns="three">
          <Grid.Row>
            {/* <Field
                name="srNumber"
                label="SR Number"
                type="text"
                disabled={fieldDisable === true && "true"}
                component={renderTextField}
              /> */}

            <Grid.Column>
              <Field
                name="purchaseDate"
                label="Date"
                type="date"
                // disabled={fieldDisable === true && "true"}
                component={renderTextField}
              />
            </Grid.Column>

            <Grid.Column>
              <Field
                name="buyerCompany"
                label="Buyer Company"
                type="text"
                // disabled={fieldDisable === true && "true"}
                component={renderTextField}
              />
            </Grid.Column>
            <Grid.Column>
              <Field
                name="buyerAccountNumber"
                label="Buye Account Number"
                type="text"
                // disabled={fieldDisable === true && "true"}
                component={renderTextField}
              />
            </Grid.Column>
          </Grid.Row>
        </Grid>
      </Grid.Row>
      <Grid.Row>
        <Grid columns="three">
          <Grid.Row>
            <Grid.Column>
              <Field
                name="description"
                label="Description"
                type="text"
                // disabled={fieldDisable === true && "true"}
                component={renderTextField}
              />
            </Grid.Column>
            <Grid.Column>
              <Field
                name="payCompany"
                label="Pay Company"
                type="text"
                // disabled={fieldDisable === true && "true"}
                component={renderTextField}
              />
            </Grid.Column>
            <Grid.Column>
              <Field
                name="bankName"
                label="Bank Name"
                type="text"
                // disabled={fieldDisable === true && "true"}
                component={renderTextField}
              />
            </Grid.Column>
          </Grid.Row>
        </Grid>
      </Grid.Row>
      <Grid.Row>
        <Grid columns="three">
          <Grid.Row>
            <Grid.Column>
              <Field
                name="chequePaymentDate"
                label="Cheque PaymentDate"
                type="date"
                // disabled={fieldDisable === true && "true"}
                component={renderTextField}
              />
            </Grid.Column>
            <Grid.Column>
              <Field
                name="debitDate"
                label="Debit Date"
                type="date"
                component={renderTextField}
              />
            </Grid.Column>
            <Grid.Column>
              <Field
                name="payment"
                label="Payment"
                type="text"
                component={renderTextField}
              />
            </Grid.Column>
          </Grid.Row>
        </Grid>
      </Grid.Row>
      <Grid.Row>
        <Grid columns="three">
          <Grid.Row>
            <Grid.Column>
              <Field
                name="toatl"
                label="Total"
                type="text"
                // disabled={fieldDisable === true && "true"}
                component={renderTextField}
              />
            </Grid.Column>
            <Grid.Column>
              <Field
                name="remark"
                label="Remarks"
                type="text"
                component={renderTextField}
              />
              {/* <Field
                name="status"
                label="Status"
                options={statusVal}
                component={renderOptionField}
              /> */}
            </Grid.Column>
            <Grid.Column>
              {/* <div
                style={{
                  marginTop: "25px",
                }}
              >
                <Field
                  name="chequeCopy"
                  type="file"
                  component={ImageFileUploadFileId}
                  label="File"
                />
              </div> */}
            </Grid.Column>
          </Grid.Row>
        </Grid>
      </Grid.Row>

      <FieldArray name="fileList" component={FileUpladArr} />
      {/* <Grid.Row>
        <Grid columns="three">
          <Grid.Row>
            <Grid.Column></Grid.Column>
            <Grid.Column>
              {id != "null" && (
                <>
                  <img
                    src={BaseImgUploadUrl + downloadImage}
                    height="150px"
                    width="150px"
                  />
                  <Button
                    positive
                    onClick={(event) =>
                      handleClick(event, BaseImgUploadUrl + downloadImage)
                    }
                  >
                    Download File
                  </Button>
                </>
              )}
            </Grid.Column>
            <Grid.Column>
              <div
                style={{
                  marginTop: "25px",
                }}
              ></div>
            </Grid.Column>
          </Grid.Row>
        </Grid>
      </Grid.Row> */}
      {uploadedImageList.length > 0 && (
        <Table celled>
          <Table.Header>
            <Table.Row>
              <Table.HeaderCell>File Name</Table.HeaderCell>
              <Table.HeaderCell>Download Link</Table.HeaderCell>
            </Table.Row>
          </Table.Header>
          <Table.Body>
            {uploadedImageList.map((item, index) => (
              <Table.Row key={index}>
                <Table.Cell collapsing>{item.fileTypeName}</Table.Cell>
                <Table.Cell collapsing>
                  <p
                    style={{
                      cursor: "pointer",
                    }}
                    onClick={() =>
                      window.open(
                        ImageUrl + item.fileName,
                        "_blank",
                        "noopener,noreferrer"
                      )
                    }
                  >
                    Download
                  </p>
                </Table.Cell>
              </Table.Row>
            ))}
          </Table.Body>
        </Table>
      )}
      <br />

      <>
        <Button
          floated="right"
          positive
          disabled={buttonDisable}
          onClick={handleSubmit((values) =>
            sumbitForm({
              ...values,
            })
          )}
        >
          Save
        </Button>
        <Button
          floated="right"
          negative
          disabled={pristine || submitting}
          onClick={reset}
        >
          Cancel
        </Button>{" "}
      </>
    </div>
  );
};

export default reduxForm({
  form: "CreatePurchase",
  validate,
})(CreatePurchase);

//teamparmarit@gmail.com
